//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconStatusFilterFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.99986 11.51V21.72L14.9999 18.29V11.51L22.1399 3H1.85986L8.99986 11.51Z" fill="currentColor" /></svg>;
}
export default IconStatusFilterFill;